import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKinde } from '../../../auth/kinde';
import { urls } from '../../../routers/urls';
import Loading from '../../atoms/Loading';

const Login: React.FC = () => {
  const { login, loading, isAuthenticated } = useKinde();
  const navigate = useNavigate();
  const hasInitiatedLogin = useRef(false);

  useEffect(() => {
    // If already authenticated, redirect to home
    if (!loading && isAuthenticated) {
      navigate(urls.orderManagement, { replace: true });
      return;
    }

    // Don't initiate login if we've already initiated it
    if (!loading && !isAuthenticated && !hasInitiatedLogin.current) {
      hasInitiatedLogin.current = true;
      // handleLogin in kinde.tsx automatically adds org_code from config
      login();
    }
  }, [loading, isAuthenticated, login, navigate]);

  return <Loading />;
};
export default Login;
